import { supabase } from '@/lib/supabase';

export const testIndexing = async (paperId: string) => {
  const { data, error } = await supabase.functions.invoke('test-search-indexing', {
    body: { paperId }
  });
  
  if (error) throw error;
  return data;
};

export const retryFailedJobs = async () => {
  // Get all failed jobs
  const { data: failedJobs, error: fetchError } = await supabase
    .from('search_indexing_queue')
    .select('id')
    .eq('status', 'failed');
    
  if (fetchError) throw fetchError;
  
  // Reset them to pending
  const ids = failedJobs?.map(job => job.id) || [];
  
  if (ids.length === 0) {
    return { message: 'No failed jobs to retry', count: 0 };
  }
  
  const { error: updateError } = await supabase
    .from('search_indexing_queue')
    .update({
      status: 'pending',
      retry_count: 0,
      scheduled_at: new Date().toISOString(),
      error_message: null
    })
    .in('id', ids);
    
  if (updateError) throw updateError;
  
  return { message: `Requeued ${ids.length} failed jobs`, count: ids.length };
};
